var map = {
	"./1.jpg": 6953,
	"./1.png": 6498,
	"./10.png": 9521,
	"./2.jpg": 2703,
	"./2.png": 9770,
	"./3.jpg": 9598,
	"./3.png": 935,
	"./4.jpg": 4898,
	"./4.png": 3012,
	"./5.jpg": 1530,
	"./5.png": 8562,
	"./6.jpg": 7061,
	"./6.png": 9202,
	"./7.png": 9127,
	"./8.png": 7317,
	"./9.png": 1626,
	"./author.png": 4464,
	"./author2.png": 55,
	"./author3.png": 5784,
	"./author4.png": 3720,
	"./author5.png": 1316,
	"./beg.png": 3498,
	"./course-banner1.jpg": 7538,
	"./course-banner2.jpg": 2114,
	"./course-banner3.jpg": 7975,
	"./small-image/1.png": 9818,
	"./small-image/2.png": 8021,
	"./small-image/3.png": 7528,
	"./small-image/4.png": 127,
	"./small-image/5.png": 5222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8038;